import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import AdminGuard from './components/AdminGuard';
import { initTheme } from './lib/theme';
import AdminDashboardPage from './pages/AdminDashboardPage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminProjectPage from './pages/AdminProjectPage';
import AdminSecurityPage from './pages/AdminSecurityPage';
import AdminStoragePage from './pages/AdminStoragePage';
import LandingPage from './pages/LandingPage';
import NotFoundPage from './pages/NotFoundPage';
import ReviewPage from './pages/ReviewPage';
import './styles.css';

initTheme();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route
          path="/admin"
          element={
            <AdminGuard>
              <AdminDashboardPage />
            </AdminGuard>
          }
        />
        <Route
          path="/admin/projects/:id"
          element={
            <AdminGuard>
              <AdminProjectPage />
            </AdminGuard>
          }
        />
        <Route
          path="/admin/storage"
          element={
            <AdminGuard>
              <AdminStoragePage />
            </AdminGuard>
          }
        />
        <Route
          path="/admin/security"
          element={
            <AdminGuard>
              <AdminSecurityPage />
            </AdminGuard>
          }
        />
        <Route path="/admin/errors" element={<Navigate to="/admin/security" replace />} />
        <Route path="/r/:token" element={<ReviewPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
);
